import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GeneralConstants } from 'app/constants/general-constants';
import { StoreImpact } from 'app/model/redshift/impact-report/store-impact';
import { impactReportService } from 'app/services';
import { ImpactReportGrid } from 'features/qa/impact/impact-report-grid';

export const ImpactReports: React.FunctionComponent = () => {
    const [currentStores, setCurrentStores] = useState<StoreImpact[]>([]);
    const [isProd, setIsProd] = useState(false);

    useEffect(() => {
        const inflightStoreList = impactReportService
            .listAll({
                pageSize: GeneralConstants.PAGE_SIZE_HUGE,
                extraParams: { type: 'store', prod: isProd },
            })
            .subscribe((data) => setCurrentStores(data as StoreImpact[]));

        return () => {
            inflightStoreList.unsubscribe();
        };
    }, [isProd]);

    return (
        <>
            <Typography variant='h5'>Store Impact Report</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <FormControlLabel
                        control={
                            <Switch checked={isProd} onChange={(evt, checked) => setIsProd(checked)} name='prod' />
                        }
                        label='Prod Data'
                    />
                </Box>
            </Box>
            <ImpactReportGrid type='store' density='compact' rows={currentStores} pagination autoPageSize />
        </>
    );
};
